import { RecurrenceEnum } from "web_myplann/Infrastructure/Api/Api";
import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import type {
	ReminderTemplate,
	ResourceKey,
} from "web_myplann/Reminders/Types/ReminderTypes";

type TranslateFn = (key: ResourceKey) => string;

export const getReminderTemplateFormValues = (
	template: ReminderTemplate,
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
	t: TranslateFn,
): Partial<ReminderFormModel> => {
	const values: Partial<ReminderFormModel> = {};

	if (entityConfig.showName) {
		values.name =
			template.isCustom || !template.labelKey ? "" : t(template.labelKey);
	}

	values.recurrence = entityConfig.allowRecurrence
		? template.recurrence
		: RecurrenceEnum.Once;

	const date =
		entityConfig.resolveTemplateDate && validTo
			? entityConfig.resolveTemplateDate(template.typeKey, validTo)
			: null;

	if (date) {
		values.date = date;
	}

	values.typeKey = template.typeKey;

	return values;
};
